export default  {
  get : function(cookieName){
    var cookieParam = cookieName + "="
    var cookieSplit = document.cookie.split(';')
    for (var i = 0; i < cookieSplit.length; i++) {
      var cookiePart = cookieSplit[i];
      while (cookiePart.charAt(0) == ' ') {
        cookiePart = cookiePart.substring(1)
      }
      if (cookiePart.indexOf(cookieParam) == 0) {
        return cookiePart.substring(cookieParam.length, cookiePart.length)
      }
    }
    return false;
  },
}

